export default __webpack_public_path__ + "static/media/battery-50percentage24x24.a226e6e9.svg";